import { render, staticRenderFns } from "./EditPartsItem.vue?vue&type=template&id=6c372b88&scoped=true"
import script from "./EditPartsItem.vue?vue&type=script&lang=ts"
export * from "./EditPartsItem.vue?vue&type=script&lang=ts"
import style0 from "./EditPartsItem.vue?vue&type=style&index=0&id=6c372b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c372b88",
  null
  
)

export default component.exports